import styles from "./Container.module.scss";

export const Container: React.FC<{
    border?: boolean
}> = ({border, ...rest}) =>
    <div
        {...rest}
        className={`${styles.base} ${border ? styles.border : ""}`}
    />
